// Central content for Dr. Devratsinh Parmar's website

export const DOCTOR = {
  name: "Dr. Devratsinh Parmar",
  title: "Interventional Cardiologist",
  credentials: "MBBS · MD (General Medicine) · DM (Cardiology)",
  tagline: "Advanced Cardiovascular Care with Precision and Empathy.",
  role: "Assistant Professor in Cardiology",
  institute: "U.N. Mehta Institute of Cardiology & Research Centre (UNMICRC)",
  city: "Ahmedabad, Gujarat, India",
  phone: "+91 90811 02186",
  phoneHref: "tel:+919081102186",
  email: "drdevratsinh21@gmail.com",
  hours: "24 / 7",
  address:
    "U. N. Mehta Institute of Cardiology and Research Centre, Civil Hospital Campus, Asarwa, Ahmedabad, Gujarat",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=U.N.+Mehta+Institute+of+Cardiology+and+Research+Centre+Ahmedabad",
};

export const IMAGES = {
  heroPortrait:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_c90d03f9-31b1-49aa-a187-40e9b58764b2/artifacts/uzzgffqo_Dr%20Devratsinh%20photo.jpeg",
  aboutPortrait:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_c90d03f9-31b1-49aa-a187-40e9b58764b2/artifacts/z3b94a2j_Dr%20Devratsinh%20Photo-2.jpeg",
  orRoom:
    "https://images.unsplash.com/photo-1734094546615-045bf5f7ea0e?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400&ixlib=rb-4.1.0",
  lab:
    "https://images.unsplash.com/photo-1630959305606-3123a081dada?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400&ixlib=rb-4.1.0",
  ecg:
    "https://images.unsplash.com/photo-1682706841289-9d7ddf5eb999?crop=entropy&cs=srgb&fm=jpg&q=70&w=1400&ixlib=rb-4.1.0",
  video:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_c90d03f9-31b1-49aa-a187-40e9b58764b2/artifacts/lce54b0a_TIPS%20AND%20TRICKS%20IN%20DIFFICULT%20BMV.mp4",
  award:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_dr-devratsin-pro/artifacts/91hacz7r_cardiology%20excellence%20award.webp",
  hospitalBuilding:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_dr-devratsin-pro/artifacts/pdjmjgxp_This%20is%20the%20front%20of%20godhra.jpeg",
  hospitalLogo:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_dr-devratsin-pro/artifacts/dz8s3wkv_WhatsApp%20Image%202026-03-24%20at%204.50.19%20PM.jpeg",
};

export const HOSPITAL = {
  name: "Godhra Heart & Super Speciality Hospital LLP",
  tagline: "Where Every Heartbeat Matters.",
  phone1: "+91 99242 41831",
  phone2: "+91 99242 41832",
  phone1Href: "tel:+919924241831",
  address: "Near Bhavnagri Road, Panjara Pole Road, Godhra, Panchmahal, Gujarat",
};

export const AWARD = {
  title: "Cardiology Excellence Award",
  presenter: "Times Healthcare Leaders",
  publisher: "The Times of India",
  year: "2026",
  region: "Gujarat",
  body:
    "Recognised at the Times Healthcare Leaders — Gujarat 2026 for outstanding contribution and excellence in the field of cardiology, honouring advanced interventional practice, academic leadership and compassionate patient care.",
};

export const AWARDS = [
  {
    image: IMAGES.award,
    title: "Cardiology Excellence Award",
    org: "Times Healthcare Leaders · The Times of India",
    year: "2026",
    body:
      "Honoured at Times Healthcare Leaders — Gujarat 2026 for outstanding excellence in the field of cardiology.",
  },
  {
    image: IMAGES.orRoom,
    title: "Case Presentation — EVAR",
    org: "76th Annual Conference, Cardiological Society of India",
    year: "2024",
    body:
      "Presented 'EVAR with Difficult Vascular Access' at the national CSI conference.",
  },
  {
    image: IMAGES.lab,
    title: "Published Research",
    org: "ASEAN Heart Journal",
    year: "2025",
    body:
      "Lead study on predictors of mortality in cardiac ICU patients — international peer-reviewed publication.",
  },
  {
    image: IMAGES.ecg,
    title: "Continuous Cardiac Education",
    org: "U. N. Mehta Institute of Cardiology (UNMICRC)",
    year: "2024",
    body:
      "Delivered a teaching session on Carotid Artery Stenting — anatomy, procedure & complications.",
  },
];

export const NAV_LINKS = [
  { key: "home", label: "Home", path: "/" },
  { key: "about", label: "About", path: "/about" },
  { key: "expertise", label: "Expertise", path: "/services" },
  { key: "research", label: "Research", path: "/research" },
  { key: "media", label: "Media", path: "/media" },
  { key: "contact", label: "Contact", path: "/contact" },
];

export const STATS = [
  { value: "15+", label: "Peer-Reviewed Publications" },
  { value: "24/7", label: "Cardiac Availability" },
  { value: "DM", label: "Doctorate in Cardiology" },
  { value: "CSI", label: "National Conference Presenter" },
];

export const SERVICES = [
  {
    id: "01",
    title: "Interventional Cardiology & Vascular Procedures",
    short: "Complex catheter-based intervention",
    body:
      "Expertise in complex catheter-based treatments, including Carotid Artery Stenting and Endovascular Aneurysm Repair (EVAR) for difficult vascular access cases.",
    icon: "activity",
    featured: true,
  },
  {
    id: "02",
    title: "Heart Failure & Cardiomyopathy Management",
    short: "Advanced diagnostic therapy",
    body:
      "Advanced diagnostic and therapeutic management of restrictive cardiomyopathies, severe left ventricular (LV) dysfunction, and conditions related to systemic diseases such as Monoclonal Gammopathy.",
    icon: "heart-pulse",
  },
  {
    id: "03",
    title: "Acute Coronary Syndromes & Ischemic Heart Disease",
    short: "Heart attack & angina care",
    body:
      "Comprehensive care for heart attacks, angina, and unique cardiac events like Kounis Syndrome — allergic acute coronary syndrome.",
    icon: "zap",
  },
  {
    id: "04",
    title: "Arrhythmia & Device Implantation",
    short: "AICD & rhythm management",
    body:
      "Management of life-threatening arrhythmias such as recurrent ventricular tachycardia, and implantation of life-saving devices including Automatic Implantable Cardioverter-Defibrillators (AICD).",
    icon: "radio",
  },
  {
    id: "05",
    title: "Preventive Cardiology & Risk Assessment",
    short: "Predict & prevent",
    body:
      "Utilising the latest clinical scoring systems to evaluate traditional risk factors and prevent coronary artery disease before it becomes critical.",
    icon: "shield",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "The Clinician",
    body:
      "Dr. Devratsinh Parmar is a dedicated cardiologist with a passion for managing complex and rare cardiovascular diseases. Currently serving as an Assistant Professor in Cardiology at the prestigious U.N. Mehta Institute of Cardiology and Research Centre in Ahmedabad, he is deeply involved in both advanced patient care and the education of future cardiologists.",
  },
  {
    num: "02",
    title: "The Foundation",
    body:
      "With comprehensive medical training — an MBBS, an MD in General Medicine, and a DM in Cardiology — Dr. Parmar has built a strong foundation in diagnosing and treating high-risk cardiac conditions. His clinical approach is rooted in evidence-based medicine, ensuring every patient receives a tailored, highly effective treatment plan.",
  },
  {
    num: "03",
    title: "The Specialist",
    body:
      "Beyond routine cardiology, Dr. Parmar holds special expertise in advanced endovascular procedures such as Endovascular Aneurysm Repair (EVAR) and Carotid Artery Stenting, as well as the management of rare cardiomyopathies and complex arrhythmias.",
  },
];

export const PUBLICATIONS = [
  {
    title:
      "Predictors of Mortality by Various Parameters in Cardiac ICU Patients: A Prospective Study",
    journal: "ASEAN Heart Journal",
    year: "2025",
    doi: "10.31762/AHJ2534.0302",
  },
  {
    title:
      "To Evaluate Efficiency of Various Coronary Artery Disease Risk Scores With Traditional Risk Factors in Patients Undergoing Coronary Angiography",
    journal: "Journal of the Saudi Heart Association",
    year: "2024",
    doi: "10.37616/2212-5043.1386",
  },
  {
    title:
      "Correlation between Cardiac Output Measured by Fick's Principle with Non-Invasive Assessment and In-Hospital Prognostic Implication of Venous Saturation",
    journal: "European Journal of Cardiovascular Medicine",
    year: "",
    doi: "10.61336/ejcm/26-01-91",
  },
  {
    title:
      "Relationship between Different Cardiovascular Risk Scores and Measures of Subclinical Atherosclerosis in an Indian Population",
    journal: "Indian Heart Journal",
    year: "2015",
    doi: "10.1016/j.ihj.2015.04.017",
  },
  {
    title:
      "Evaluation of SERENE-CAG Score for Assessing Suitability for Coronary Angiography Preoperatively in Patients Undergoing Valve Replacement Surgery",
    journal: "Indian Heart Journal",
    year: "",
    doi: "10.1016/j.ihj.2018.10.033",
  },
];

export const CASE_REPORTS = [
  {
    title: "EVAR with Difficult Vascular Access",
    body:
      "Presented at the 76th Annual Conference of the Cardiological Society of India.",
  },
  {
    title: "Carotid Artery Stenting",
    body:
      "Anatomy, Procedure & Complications — Continuous Cardiac Education Session, UNMICRC.",
  },
  {
    title: "Cardiac Sarcoidosis",
    body:
      "Successfully managed a rare presentation of recurrent ventricular tachycardia with severe LV dysfunction using AICD implantation.",
  },
  {
    title: "Kounis Syndrome",
    body:
      "Diagnosis and management of allergic acute coronary syndrome in young adults without pre-existing coronary artery disease.",
  },
  {
    title: "Restrictive Cardiomyopathy",
    body:
      "Identified and managed complex diastolic dysfunction secondary to monoclonal gammopathy.",
  },
];
